import { Controller } from "@hotwired/stimulus"

// Usage example on `app/views/users/edit.haml`:
//   .panel.panel-info{ data: { controller: 'users--edit-address-books' } }
//     .panel-heading#address-book-head{
//        title: 'Click to expand',
//        data: { action: 'click->users--edit-address-books#toggle' }
//      }
//       Address books (click to expand/collapse)
//     .panel-body#users-address-books{
//        style: 'display: none;',
//        data: { 'users--edit-address-books-target': 'body' }
//      }
export default class extends Controller {
  static targets = ["body"]

  toggle(event) {
    if (event) event.preventDefault()
    if (this.hasBodyTarget) {
      $(this.bodyTarget).toggle(200)
    }
  }
}
